// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"42856d3a","425":"af1a8da5","968":"bbdff1dd"}[chunkId] + ".chunk.js";
};